<template>
  <form novalidate>
    <h4 class="h4 text--bold text--uppercase">Conclusiones (SOLO PARA EL FUNCIONARIO)</h4>

    <form-group :error="errors.has('sabeTipoDepredador') && submitted">
      <label class="form__label form__label--required">
        38. Se logró determinar la especie que causó el/los ataque(s) de depredación?
      </label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.sabeTipoDepredador"
        id="sisabeTipoDepredador"
        name="sabeTipoDepredador"
        v-validate="'required'"
        :value="true">
        <label class="form__label" for="sisabeTipoDepredador">
          Si
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.sabeTipoDepredador"
        id="nosabeTipoDepredador"
        name="sabeTipoDepredador"
        v-validate="'required'"
        :value="false">
        <label class="form__label" for="nosabeTipoDepredador">
          No
        </label>
      </div>
      <div class="identado">
        <form-group
        v-if="form.sabeTipoDepredador"
        :error="errors.has('tipoDepredador') && submitted">
          <label class="form__label form__label--required">
            Cuál especie?
          </label>
          <div class="radio radio--azul">
            <input
            :disabled="!editando" type="radio" id="1tipoDepredador" name="tipoDepredador"
            v-model="form.tipoDepredador" value="Jaguar/tigre/pantera" v-validate="'required'">
            <label class="form__label" for="1tipoDepredador">
              Jaguar/tigre/pantera
            </label>
          </div>
          <div class="radio radio--azul">
            <input
            :disabled="!editando" type="radio" id="2tipoDepredador" name="tipoDepredador"
            v-model="form.tipoDepredador" value="Puma/león" v-validate="'required'">
            <label class="form__label" for="2tipoDepredador">
              Puma/león
            </label>
          </div>
          <div class="radio radio--azul">
            <input
            :disabled="!editando" type="radio" id="3tipoDepredador" name="tipoDepredador"
            v-model="form.tipoDepredador" value="Manigordo/Ocelote" v-validate="'required'">
            <label class="form__label" for="3tipoDepredador">
              Manigordo/Ocelote
            </label>
          </div>
          <div class="radio radio--azul">
            <input
            :disabled="!editando" type="radio" id="4tipoDepredador" name="tipoDepredador"
            v-model="form.tipoDepredador" value="Yaguarundi/león breñero" v-validate="'required'">
            <label class="form__label" for="4tipoDepredador">
              Yaguarundi/león breñero
            </label>
          </div>
          <div class="radio radio--azul">
            <input
            :disabled="!editando" type="radio" id="5tipoDepredador" name="tipoDepredador"
            v-model="form.tipoDepredador" value="Tigrillo" v-validate="'required'">
            <label class="form__label" for="5tipoDepredador">
              Tigrillo
            </label>
          </div>
          <div class="radio radio--azul">
            <input
            :disabled="!editando" type="radio" id="6tipoDepredador" name="tipoDepredador"
            v-model="form.tipoDepredador" value="Coyote" v-validate="'required'">
            <label class="form__label" for="6tipoDepredador">
              Coyote
            </label>
          </div>
          <div class="radio radio--azul">
            <input
            :disabled="!editando" type="radio" id="7tipoDepredador" name="tipoDepredador"
            v-model="form.tipoDepredador" value="Perro" v-validate="'required'">
            <label class="form__label" for="7tipoDepredador">
              Perro
            </label>
          </div>
          <div class="radio radio--azul">
            <input
            :disabled="!editando" type="radio" id="8tipoDepredador" name="tipoDepredador"
            v-model="form.tipoDepredador" value="Otra" v-validate="'required'">
            <label class="form__label" for="8tipoDepredador">
              Otra
            </label>
          </div>
          <form-group :error="errors.has('otratipoDepredador') && submitted"
          v-if="form.tipoDepredador === 'Otra'">
            <input
            data-vv-validate-on="blur"
            :disabled="!editando"
            type="text"
            class="form__input"
            v-model="form.otraTipoDepredador"
            name="otratipoDepredador"
            required
            v-validate="'required'">
            <label class="form__label">
              Especifique:
            </label>
          </form-group>
        </form-group>
        <form-group
        v-if="form.sabeTipoDepredador"
        :error="errors.has('razonTipoDepredador') && submitted">
          <label class="form__label form__label--required">
            Debido a que:
          </label>
          <div class="checkbox checkbox--azul">
            <input v-validate="'required'"
            :disabled="!editando" type="checkbox" id="1razonTipoDepredador"
            name="razonTipoDepredador" v-model="form.razonTipoDepredador"
            value="Presencia de huellas">
            <label class="form__label" for="1razonTipoDepredador">
              Presencia de huellas
            </label>
          </div>
          <div class="checkbox checkbox--azul">
            <input v-validate="'required'"
            :disabled="!editando" type="checkbox" id="2razonTipoDepredador"
            name="razonTipoDepredador" v-model="form.razonTipoDepredador"
            value="Forma de matar / atacar">
            <label class="form__label" for="2razonTipoDepredador">
              Forma de matar / atacar
            </label>
          </div>
          <div class="checkbox checkbox--azul">
            <input v-validate="'required'"
            :disabled="!editando" type="checkbox" id="3razonTipoDepredador"
            name="razonTipoDepredador" v-model="form.razonTipoDepredador" value="Forma de comer">
            <label class="form__label" for="3razonTipoDepredador">
              Forma de comer
            </label>
          </div>
          <div class="checkbox checkbox--azul">
            <input v-validate="'required'"
            :disabled="!editando" type="checkbox" id="4razonTipoDepredador"
            name="razonTipoDepredador" v-model="form.razonTipoDepredador"
            value="Cubrió la presa con vegetación">
            <label class="form__label" for="4razonTipoDepredador">
              Cubrió la presa con vegetación
            </label>
          </div>
          <div class="checkbox checkbox--azul">
            <input v-validate="'required'"
            :disabled="!editando" type="checkbox" id="5razonTipoDepredador"
            name="razonTipoDepredador" v-model="form.razonTipoDepredador"
            value="Descripción del ataque por medio del
            entrevistado">
            <label class="form__label" for="5razonTipoDepredador">
              Descripción del ataque por medio del entrevistado
            </label>
          </div>
          <div class="checkbox checkbox--azul">
            <input v-validate="'required'"
            :disabled="!editando" type="checkbox" id="6razonTipoDepredador"
            name="razonTipoDepredador" v-model="form.razonTipoDepredador"
            value="Existencia de registro fotográfico">
            <label class="form__label" for="6razonTipoDepredador">
              Existencia de registro fotográfico
            </label>
          </div>
          <div class="checkbox checkbox--azul">
            <input v-validate="'required'"
            :disabled="!editando" type="checkbox" id="7razonTipoDepredador"
            name="razonTipoDepredador" v-model="form.razonTipoDepredador" value="Otra">
            <label class="form__label" for="7razonTipoDepredador">
              Otra
            </label>
          </div>
          <form-group :error="errors.has('otratipoDepredador') && submitted"
          v-if="form.razonTipoDepredador.includes('Otra')">
            <input
            data-vv-validate-on="blur"
            :disabled="!editando"
            type="text"
            class="form__input"
            v-model="form.otraRazonTipoDepredador"
            name="otratipoDepredador"
            required
            v-validate="'required'">
            <label class="form__label">
              Especifique:
            </label>
          </form-group>
        </form-group>
      </div>
    </form-group>

    <form-group :error="errors.has('razonesDepredacion') && submitted">
      <label class="form__label form__label--required">
        39. ¿Cuáles son las 2 o 3 probables razones que según usted, podrían estar
        propiciando los ataques de depredación en la propiedad?
      </label>
      <div class="checkbox checkbox--azul">
        <input v-validate="'required'"
        :disabled="!editando" type="checkbox" id="1razonesDepredacion" name="razonesDepredacion"
        v-model="form.razonesDepredacion" value="No hay presencia humana diaria">
        <label class="form__label" for="1razonesDepredacion">
          No hay presencia humana diaria
        </label>
      </div>
      <div class="checkbox checkbox--azul">
        <input v-validate="'required'"
        :disabled="!editando" type="checkbox" id="2razonesDepredacion" name="razonesDepredacion"
        v-model="form.razonesDepredacion" value="No hay gallineros/encierros">
        <label class="form__label" for="2razonesDepredacion">
          No hay gallineros/encierros
        </label>
      </div>
      <div class="checkbox checkbox--azul">
        <input v-validate="'required'"
        :disabled="!editando" type="checkbox" id="3razonesDepredacion" name="razonesDepredacion"
        v-model="form.razonesDepredacion" value="Las aves ingresan al bosque">
        <label class="form__label" for="3razonesDepredacion">
          Las aves ingresan al bosque
        </label>
      </div>
      <div class="checkbox checkbox--azul">
        <input v-validate="'required'"
        :disabled="!editando" type="checkbox" id="4razonesDepredacion" name="razonesDepredacion"
        v-model="form.razonesDepredacion" value="Las aves andan libres todo el día">
        <label class="form__label" for="4razonesDepredacion">
          Las aves andan libres todo el día
        </label>
      </div>
      <div class="checkbox checkbox--azul">
        <input v-validate="'required'"
        :disabled="!editando" type="checkbox" id="5razonesDepredacion" name="razonesDepredacion"
        v-model="form.razonesDepredacion" value="La persona/dueño es muy descuidado">
        <label class="form__label" for="5razonesDepredacion">
          La persona/dueño es muy descuidado
        </label>
      </div>
      <div class="checkbox checkbox--azul">
        <input v-validate="'required'"
        :disabled="!editando" type="checkbox" id="6razonesDepredacion" name="razonesDepredacion"
        v-model="form.razonesDepredacion" value="La propiedad está muy encharralada">
        <label class="form__label" for="6razonesDepredacion">
          La propiedad está muy encharralada
        </label>
      </div>
      <div class="checkbox checkbox--azul">
        <input v-validate="'required'"
        :disabled="!editando" type="checkbox" id="7razonesDepredacion" name="razonesDepredacion"
        v-model="form.razonesDepredacion" value="Las instalaciones o encierros están en mal estado">
        <label class="form__label" for="7razonesDepredacion">
          Las instalaciones o encierros están en mal estado
        </label>
      </div>
      <div class="checkbox checkbox--azul">
        <input v-validate="'required'"
        :disabled="!editando" type="checkbox" id="8razonesDepredacion" name="razonesDepredacion"
        v-model="form.razonesDepredacion" value="Propiedad con o rodeada de mucha cobertura
        forestal o en regeneración">
        <label class="form__label" for="8razonesDepredacion">
          Propiedad con o rodeada de mucha cobertura forestal o en regeneración
        </label>
      </div>
      <div class="checkbox checkbox--azul">
        <input v-validate="'required'"
        :disabled="!editando" type="checkbox" id="9razonesDepredacion" name="razonesDepredacion"
        v-model="form.razonesDepredacion" value="Dentro o en los alrededores de la propiedad
        hay mucha cacería">
        <label class="form__label" for="9razonesDepredacion">
          Dentro o en los alrededores de la propiedad hay mucha cacería
        </label>
      </div>
      <div class="checkbox checkbox--azul">
        <input v-validate="'required'"
        :disabled="!editando" type="checkbox" id="10razonesDepredacion" name="razonesDepredacion"
        v-model="form.razonesDepredacion" value="Otra">
        <label class="form__label" for="10razonesDepredacion">
          Otra
        </label>
      </div>
      <div class="identado">
        <form-group :error="errors.has('otrarazonesDepredacion') && submitted"
        v-if="form.razonesDepredacion.includes('Otra')">
          <input
          data-vv-validate-on="blur"
          :disabled="!editando"
          type="text"
          class="form__input"
          v-model="form.otraRazonesDepredacion"
          name="otrarazonesDepredacion"
          required
          v-validate="'required'">
          <label class="form__label">
            Especifique:
          </label>
        </form-group>
      </div>
    </form-group>

    <div>
      <label class="form__label form__label--required">
        40. Escriba 3 recomendaciones dadas al afectado o acciones
        realizadas en el acto en la propiedad
      </label>
      <div v-if="!form.noRecomendo">
        <form-group :error="errors.has('recomendacion1') && submitted">
          <input
          data-vv-validate-on="blur"
          :disabled="!editando"
          type="text"
          class="form__input"
          v-model="form.recomendacion1"
          name="recomendacion1"
          required
          v-validate="'required'">
          <label class="form__label">
            1.
          </label>
        </form-group>
        <form-group :error="errors.has('recomendacion2') && submitted">
          <input
          data-vv-validate-on="blur"
          :disabled="!editando"
          type="text"
          class="form__input"
          v-model="form.recomendacion2"
          name="recomendacion2"
          required
          v-validate="'required'">
          <label class="form__label">
            2.
          </label>
        </form-group>
        <form-group :error="errors.has('recomendacion3') && submitted">
          <input
          data-vv-validate-on="blur"
          :disabled="!editando"
          type="text"
          class="form__input"
          v-model="form.recomendacion3"
          name="recomendacion3"
          required
          v-validate="'required'">
          <label class="form__label">
            3.
          </label>
        </form-group>
      </div>
    </div>

    <div class="checkbox checkbox--azul">
      <input
      :disabled="!editando"
      type="checkbox"
      v-model="form.noRecomendo"
      id="sinoRecomendo"
      name="noRecomendo"
      :value="true">
      <label class="form__label" for="sinoRecomendo">
        No recomendé ni implementé nada debido a que:
      </label>
    </div>
    <div class="identado">
      <form-group :error="errors.has('razonNoRecomendacion') && submitted"
      v-if="form.noRecomendo">
        <input
        data-vv-validate-on="blur"
        :disabled="!editando"
        type="text"
        class="form__input"
        v-model="form.razonNoRecomendacion"
        name="razonNoRecomendacion"
        required
        v-validate="'required'">
      </form-group>
    </div>

    <form-group :error="errors.has('seAplicaEstrategia') && submitted">
      <label class="form__label form__label--required">
        41. ¿Se implementó o implementará alguna estrategia anti-depredatoria en la propiedad?
      </label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.seAplicaEstrategia"
        id="siseAplicaEstrategia"
        name="seAplicaEstrategia"
        v-validate="'required'"
        :value="true">
        <label class="form__label" for="siseAplicaEstrategia">
          Si
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.seAplicaEstrategia"
        id="noseAplicaEstrategia"
        name="seAplicaEstrategia"
        v-validate="'required'"
        :value="false">
        <label class="form__label" for="noseAplicaEstrategia">
          No
        </label>
      </div>
      <div class="identado">
        <form-group :error="errors.has('tipoEstrategia') && submitted"
        v-if="form.seAplicaEstrategia">
          <input
          data-vv-validate-on="blur"
          :disabled="!editando"
          type="text"
          class="form__input"
          v-model="form.tipoEstrategia"
          name="tipoEstrategia"
          required
          v-validate="'required'">
          <label class="form__label" for="tipoEstrategia">
            Tipo de estrategia
          </label>
        </form-group>
        <form-group :error="errors.has('justificacionEstrategia') && submitted"
        v-if="form.seAplicaEstrategia">
          <textarea
          data-vv-validate-on="blur"
          v-if="editando"
          type="text"
          class="form__input"
          v-model="form.justificacionEstrategia"
          name="justificacionEstrategia"
          required
          v-validate="'required'"/>
          <p class="text" v-else>{{form.justificacionEstrategia}}</p>
          <label class="form__label" for="justificacionEstrategia">
            Justifique porqué escogió esa estrategia
          </label>
        </form-group>
        <form-group :error="errors.has('justificacionNoEstrategia') && submitted"
        v-if="form.seAplicaEstrategia === false">
          <textarea
          data-vv-validate-on="blur"
          v-if="editando"
          type="text"
          class="form__input"
          v-model="form.justificacionNoEstrategia"
          name="justificacionNoEstrategia"
          required
          v-validate="'required'"/>
          <p class="text" v-else>{{form.justificacionNoEstrategia}}</p>
          <label class="form__label form__label--required" for="justificacionNoEstrategia">
            Justifique porqué decidió no implementar nada
          </label>
        </form-group>
      </div>
    </form-group>

  </form>
</template>

<script>
export default {
  name: "FormAvesBloque7",
  props: {
    editando: Boolean,
    submitted: Boolean,
    form: Object,
  },
  methods: {
    validar,
  },
};

function validar() {
  return this.$validator.validate();
}
</script>
